import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadPdf = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", id: "Capa_1", x: "0px", y: "0px", viewBox: "0 0 512 512", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", width: 512, height: 512, ref, ...props }, /* @__PURE__ */ React.createElement("g", { id: "Download_pdf" }, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M332,376h-30V256h30c22.091,0,40,17.909,40,40v40C372,358.091,354.091,376,332,376z" }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 432, y1: 256, x2: 432, y2: 376 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 432, y1: 256, x2: 492, y2: 256 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 472, y1: 316, x2: 432, y2: 316 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 172, y1: 376, x2: 172, y2: 256 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M212,256h-40v60h40c16.569,0,30-13.431,30-30v0C242,269.431,228.569,256,212,256z" }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 180, y1: 96, x2: 180, y2: 176 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M340,174.179V100c0-11.046-4.478-21.046-11.716-28.284l-40-40C281.045,24.477,271.045,20,260,20H60c-22.091,0-40,17.909-40,40v392\n		c0,22.091,17.909,40,40,40h229.774c22.089,0,40-17.905,40-39.994c0-0.002,0-0.004,0-0.006" }), /* @__PURE__ */ React.createElement("polyline", { style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, points: "\n		140,136 180,176 220,136 	" })));
const ForwardRef = forwardRef(SvgDownloadPdf);
export { ForwardRef as ReactComponent };
